/**
 * Requires a wrapper from template
 * `partials/contact-form-modal-outer.html`
 * (which is returned by `ContactFormModal::getHtml()`)
 * to be placed in the body.
 * Then it loads html content from template
 * `partials/contact-form-modal-inner.html'
 * into it by ajax.
 */

import axios from 'axios'

import { getBaseHref } from '../shared/env'
import { store } from '../redux/store'
import { close as closeContactFormModal } from '../redux/contact-form-modal-slice'

/* Elements */
let wrapperEl
let formEl
let buttonCloseEl
let stepEls
let step1SubmitBtEl
let step2SubmitBtEl
let step3AcceptBtEl
let unfoldableWrapperEls
let controlWrapperEls

/* State vars */
let isOpen = false
let step = 0
let loading = false

/* Control names to remember (do not reset) */
const controlNamesToRemember = ['nombre', 'email', 'telefono', 'empresa_centro']

const onDomContentLoaded = () =>
{
    /* Find elements */
    wrapperEl = document.querySelector('.contact-form-modal')

    /* If found, bind events */
    if (wrapperEl !== undefined)
    {
        /* Store change event */
        store.subscribe(onStoreChange)

        /* Call onStoreChange for it may have already change */
        onStoreChange()
    }
}

const onStoreChange = () => {
    const state = store.getState().contactFormModal
    if (state.isOpen !== isOpen) {
        isOpen = state.isOpen
        if (isOpen) {
            loadForm(state)
        } else {
            removeForm()
        }
    }
}

const loadForm = (state) => {
    console.log('Opening contact form modal')
    isOpen = true
    wrapperEl.style.display = 'block'
    console.log(state)
    axios.post(getBaseHref() + 'ajax/contact-form-modal/content',
        axios.toFormData({
            case: state.case,
            product_id: state.product_id,
            page_url: window.location.href,
        }))
        .then((ajaxResponse) => {
            const data = ajaxResponse.data
            wrapperEl.innerHTML = data.html;
            setTimeout(() => {
                initContent();
            }, 1);
        })
        .catch((error) => {
            alert('unknown error')
            console.log(error)
        })
}

const removeForm = () => {
    wrapperEl.style.display = 'none'
    if (wrapperEl)
    {
        wrapperEl.innerHTML = ''
    }
    isOpen = false
}

const initContent = () => {
    /* Get elements */
    formEl = wrapperEl.querySelector('form')
    buttonCloseEl = wrapperEl.querySelector('.button-close')
    stepEls = wrapperEl.querySelectorAll('.step') 
    step1SubmitBtEl = stepEls[0].querySelector('.button-next')
    step2SubmitBtEl = stepEls[1].querySelector('.button-submit')
    step3AcceptBtEl = stepEls[2].querySelector('.button-accept')
    unfoldableWrapperEls = wrapperEl.querySelectorAll('.unfoldable-wrapper')
    controlWrapperEls = wrapperEl.querySelectorAll('.control-wrapper')

    /* If found, bind events */
    if (wrapperEl !== undefined)
    {
        formEl.addEventListener('click', onFormClick)
        buttonCloseEl.addEventListener('click', () => { store.dispatch(closeContactFormModal()) })
        step1SubmitBtEl.addEventListener('click', () => { onStepSubmitBtClick(1) })
        step2SubmitBtEl.addEventListener('click', () => { onStepSubmitBtClick(2) })
        step3AcceptBtEl.addEventListener('click', () => { store.dispatch(closeContactFormModal()) })
        initFoldableWrappers()
    }
}

const onFormClick = (event) => {
    event.stopPropagation()
}

const onStepSubmitBtClick = (submitStep) => {
    /* Just send form data */
    markFieldErrors([])
    setLoading(true)
    axios.post(getBaseHref() + 'ajax/contact-form-modal/step-submit/'+submitStep, formEl)
        .then((ajaxResponse) => {
            setLoading(false)
            const data = ajaxResponse.data
            if (data.status == 'sent') {
                setStep(submitStep + 1)
            } else if (data.status == 'field-errors') {
                markFieldErrors(data.fieldsWithError);
            } else  {
                alert('unexpected error')
            }
        })
        .catch((error) => {
            setLoading(false)
            alert('unknown error')
            console.log(error)
        })
}

const onStep3AcceptBtClick = (step) =>
{
    resetForm()
}

const setStep = (newStep) =>
{
    step = newStep
    for (let i = 0; i < stepEls.length; i++)
    {
        if (i + 1 === step)
        {
            stepEls[i].classList.add('active')
        }
        else
        {
            stepEls[i].classList.remove('active')
        }
    }
}

const setLoading = (newLoading) =>
{
    if (newLoading != loading)
    {
        loading = newLoading;
        if (loading)
        {
            wrapperEl.classList.add('loading')
        }
        else
        {
            wrapperEl.classList.remove('loading')
        }
    }
}

const initFoldableWrappers = () =>
{
    for (const foldableWrapperEl of unfoldableWrapperEls)
    {
        const buttonEl = foldableWrapperEl.querySelector('button')
        const iconEl = buttonEl.querySelector('.icon')
        buttonEl.addEventListener('click', () => {
            foldableWrapperEl.classList.toggle('unfolded')
        })
    }
}

const closeFoldableWrappers = () =>
{
    for (const foldableWrapperEl of unfoldableWrapperEls)
    {
        foldableWrapperEl.classList.remove('unfolded')
    }
}

const markFieldErrors = (fieldsWithError) =>
{
    for (const controlWrapperEl of controlWrapperEls)
    {
        const controlEl = controlWrapperEl.classList.contains('checkboxes-wrapper') ?
            controlWrapperEl : controlWrapperEl.querySelector('input, textarea, select')
        if (controlEl && fieldsWithError.includes(controlWrapperEl.dataset.name))
        {
            controlWrapperEl.classList.add('error')
        }
        else
        {
            controlWrapperEl.classList.remove('error')
        }
    }
}

const resetControls = () => {
    /* Reset all controls exept the ones to remember */
    for (const controlWrapperEl of controlWrapperEls)
    {
        const controlEl = controlWrapperEl.querySelector('input, textarea, select')
        if (controlEl && !controlNamesToRemember.includes(controlEl.getAttribute('name')))
        {
            const valueEls = controlWrapperEl.querySelectorAll('input[type="text"], textarea, select')
            const checkEls = controlWrapperEl.querySelectorAll('input[type="checkbox"]')
            for (const controlEl of valueEls)
            {
                const defaultValue = controlEl.dataset.defaultValue
                if (defaultValue !== undefined)
                {
                    controlEl.value = defaultValue 
                } else {
                    controlEl.value = ''
                }
            }
            for (const controlEl of checkEls)
            {
                controlEl.checked = false
            }
        }
    }
}

const resetForm = () =>
{
    closeFoldableWrappers()
    markFieldErrors([])
    resetControls()
    setStep(1)
}

document.addEventListener('DOMContentLoaded', () => {
    onDomContentLoaded()
})
